import type { TFunction } from 'i18next'

import { createErrorMapRule } from '../utils/create-rule.ts'
import type { TranslationKey } from '../utils/types.ts'

export const invalidStringRule = (t: TFunction<'validation'>) =>
  createErrorMapRule('invalid_format', t, (issue, _, t) => {
    let translationKey: TranslationKey = 'string.invalid'
    const issueData = {
      ...issue,
      startsWith: 'prefix' in issue ? issue.prefix : undefined,
      endsWith: 'suffix' in issue ? issue.suffix : undefined,
      validation: issue.format,
    }

    if (issue.format === 'includes') {
      translationKey =
        typeof (issue as { position?: number }).position === 'number'
          ? 'string.missing-character-at-position'
          : 'string.missing-character'
    } else if (issue.format === 'starts_with') {
      translationKey = 'string.missing-start'
    } else if (issue.format === 'ends_with') {
      translationKey = 'string.missing-end'
    } else if (issue.format !== 'regex') {
      translationKey = 'string.invalid-pattern'
    }

    return {
      message: t(translationKey, issueData),
    }
  })
